const origin = {
  production: window.location.origin.replace(/(console\.|admin\.)/g, ""),
  development: "http://127.0.0.1:8000",
};
const socketOrigin = {
  production: window.location.origin.replace(/(console\.|admin\.)/g, "node."),
  development: "https://node.karmaba.ir",
};

export const hostname = origin[process.env.NODE_ENV];
export const socketHostname = socketOrigin[process.env.NODE_ENV];

export const base_url = `${hostname}`;
